import { render, staticRenderFns } from "./BannerList.vue?vue&type=template&id=10fae7bc&scoped=true"
import script from "./BannerList.vue?vue&type=script&lang=js"
export * from "./BannerList.vue?vue&type=script&lang=js"
import style0 from "./BannerList.vue?vue&type=style&index=0&id=10fae7bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fae7bc",
  null
  
)

export default component.exports